import React from 'react';

// SVG paths and stroke geometry from SeeWard_Light_Resource_Experience.html.
const paths = {
  'menu': 'M4 6h16M4 12h16M4 18h16',
  'shield': 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z M9 12l2 2 4-4',
  'building': 'M3 21h18M5 21V5l7-3 7 3v16M9 9h1M14 9h1M9 13h1M14 13h1M9 17h1M14 17h1',
  'layers': 'm12 2 9 5-9 5-9-5 9-5Zm-9 10 9 5 9-5M3 17l9 5 9-5',
  'folder': 'M3 7a2 2 0 0 1 2-2h5l2 2h7a2 2 0 0 1 2 2v10H3V7Z',
  'chev': 'm6 9 6 6 6-6',
  'right': 'm9 18 6-6-6-6',
  'down': 'm6 9 6 6 6-6',
  'up': 'm6 15 6-6 6 6',
  'search': 'm21 21-4.34-4.34M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0',
  'bell': 'M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4',
  'gear': 'M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm7-3.5 2-1-2-4-2 1-2-1-.5-2.5h-5L9 7l-2 1-2-1-2 4 2 1v2l-2 1 2 4 2-1 2 1 .5 2.5h5L15 19l2-1 2 1 2-4-2-1v-2Z',
  'users': 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75',
  'userplus': 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM19 8v6M16 11h6',
  'dashboard': 'M3 3h8v8H3zM13 3h8v5h-8zM13 10h8v11h-8zM3 13h8v8H3z',
  'list': 'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01',
  'audit': 'M12 8v5l3 2M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0',
  'plus': 'M12 5v14M5 12h14',
  'x': 'M18 6 6 18M6 6l12 12',
  'check': 'M20 6 9 17l-5-5',
  'star': 'm12 2 3 6 7 .9-5 4.9 1.2 7L12 17.5 5.8 20.8 7 13.8 2 8.9 9 8l3-6Z',
  'ellipsis': 'M5 12h.01M12 12h.01M19 12h.01',
  'external': 'M13 5h6v6M19 5l-9 9M19 13v6H5V5h6',
  'lock': 'M5 11h14v10H5zM8 11V7a4 4 0 1 1 8 0v4',
  'key': 'M21 2l-2 2M16 5l3 3M14 8a6 6 0 1 0-6 6l4-4 4 4 3-3-3-3 2-2',
  'logout': 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9',
  'copy': 'M8 4h12v14H8zM4 8H3v13h12v-1',
  'info': 'M12 17v-5M12 8h.01M22 12A10 10 0 1 1 2 12a10 10 0 0 1 20 0',
  'activity': 'M3 12h4l3-8 4 16 3-8h4',
  'code': 'M8 8l-4 4 4 4M16 8l4 4-4 4M14 4l-4 16',
  'server': 'M4 3h16v7H4zM4 14h16v7H4zM8 7h.01M8 18h.01',
  'globe': 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20ZM2 12h20M12 2a16 16 0 0 1 0 20M12 2a16 16 0 0 0 0 20',
  'upload': 'M12 16V3m-5 5 5-5 5 5M4 17v4h16v-4',
  'download': 'M12 3v13m-5-5 5 5 5-5M4 18v3h16v-3',
  'file': 'M14 2H6v20h12V8l-4-6ZM14 2v6h6M9 13h6M9 17h6',
  'refresh': 'M20 7v5h-5M4 17v-5h5M6 8a7 7 0 0 1 12-2l2 6M4 12l2 6a7 7 0 0 0 12-2',
  'back': 'm15 18-6-6 6-6',
  'filter': 'M4 7h16M7 12h10M10 17h4',
  'edit': 'M3 17l-1 5 5-1L20 8l-4-4L3 17ZM14 6l4 4',
  'trash': 'M3 6h18M8 6V4h8v2M6 6l1 15h10l1-15M10 10v8M14 10v8',
  'mail': 'M3 5h18v14H3zM3 6l9 8 9-8',
  'cloud': 'M20 17a4 4 0 0 0-1-7.87A7 7 0 0 0 5 11a3 3 0 0 0 0 6h15Z',
  'eye': 'M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  'alert': 'M12 3 2 21h20L12 3ZM12 10v5M12 18h.01',
  'trend': 'm2 18 7-7 4 4 9-10M16 5h6v6',
  'link': 'M10 13a5 5 0 0 0 7 .5l3-3a5 5 0 0 0-7-7l-2 2M14 11a5 5 0 0 0-7-.5l-3 3a5 5 0 0 0 7 7l2-2'
} as const;
export type ResourceIconName = keyof typeof paths;
export default function ResourceIcon({ name, size = 17 }: { name: ResourceIconName; size?: number }) {
  return <svg
    className="sw-icon"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    aria-hidden="true"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d={paths[name]} />
  </svg>;
}
export const kindName = {
  organisation: 'Organisation',
  entity: 'Entity',
  workspace: 'Workspace'
};
export const kindIcon = {
  organisation: 'building',
  entity: 'layers',
  workspace: 'folder'
} as const;
